import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-moon",
  "use": "icon-moon-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol viewBox=\"0 0 100 100\" id=\"icon-moon\">\n  <path d=\"M49.99,11.11c-2.42,0-4.78,.23-7.08,.65,13.59,3.06,23.83,16.6,23.83,32.84,0,18.5-13.27,33.49-29.65,33.49-9.6,0-18.13-5.16-23.55-13.15,5.79,14.46,19.92,24.68,36.45,24.68,21.68,0,39.25-17.57,39.25-39.25S71.67,11.11,49.99,11.11Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/moon.svg
// module id = Ux9W
// module chunks = 62